/** biome-ignore-all lint/suspicious/noArrayIndexKey: <explanation> */
"use client";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getCommentRepliesAction } from "@/actions/content.action";
import { Button } from "@/components/ui/button";
import CommentCard from "./comment-card";

type CurrentUser = { name: string; surname: string; imageUrl?: string };

interface Props {
  commentId: string;
  contentId: string;
  replyCount: number;
  isLoggedIn: boolean;
  currentUser?: CurrentUser;
}

const SKELETON_COUNT = 3;
const CommentReplies = ({
  commentId,
  contentId,
  replyCount,
  isLoggedIn,
  currentUser,
}: Props) => {
  const [enabled, setEnabled] = useState(false);

  const { data, isFetching } = useQuery({
    enabled,
    queryFn: () => getCommentRepliesAction(commentId),
    queryKey: ["replies", commentId],
  });

  if (!enabled) {
    return (
      <Button
        className="mt-3 text-brand-blue-500 border border-brand-blue-200 rounded-full px-4"
        onClick={() => setEnabled(true)}
        size="sm"
        variant="outline"
      >
        Tüm Yanıtları Gör ({replyCount})
      </Button>
    );
  }

  if (isFetching) {
    return (
      <div className="mt-3 pl-4 border-l border-neutral-100 space-y-4">
        {Array.from({ length: Math.min(replyCount, SKELETON_COUNT) }).map((_, i) => (
          <div className="flex gap-3" key={i}>
            <div className="size-8 rounded-full bg-neutral-200 animate-pulse shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="h-3 w-24 bg-neutral-200 animate-pulse rounded" />
              <div className="h-3 w-full bg-neutral-200 animate-pulse rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mt-1 pl-4 border-l-2 border-neutral-100">
      {data?.data.map((reply) => (
        <CommentCard
          comment={reply}
          contentId={contentId}
          currentUser={currentUser}
          isLoggedIn={isLoggedIn}
          isReply={true}
          key={reply.id}
        />
      ))}
    </div>
  );
};

export default CommentReplies;
